import { render } from "./GrandMenu.vue?vue&type=template&id=a5d4d046"
import script from "./GrandMenu.vue?vue&type=script&lang=ts"
export * from "./GrandMenu.vue?vue&type=script&lang=ts"
script.render = render

export default script